import { useState, type FormEvent } from "react";
import { useCreate, useGetIdentity, useNotify } from "ra-core";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import type { Contact } from "@/components/atomic-crm/types";
import { formatClientUpdate, updateChannels, updateKinds } from "./workflow";

export const NarsQuickUpdate = ({ contact }: { contact: Contact }) => {
  const { identity } = useGetIdentity();
  const notify = useNotify();
  const [create, { isPending }] = useCreate();
  const [kind, setKind] = useState<string>("Nota interna");
  const [channel, setChannel] = useState<string>("Email");
  const [text, setText] = useState("");
  const [failed, setFailed] = useState(false);
  const submit = (event: FormEvent) => {
    event.preventDefault();
    if (!identity || !text.trim() || isPending) return;
    setFailed(false);
    create(
      "contact_notes",
      {
        data: {
          contact_id: contact.id,
          sales_id: identity.id,
          date: new Date().toISOString(),
          status: contact.status,
          text: formatClientUpdate(kind, channel, text),
        },
      },
      {
        onSuccess: () => {
          setText("");
          notify("Aggiornamento salvato");
        },
        onError: () => setFailed(true),
      },
    );
  };
  return (
    <form
      onSubmit={submit}
      className="mb-6 space-y-3"
      aria-label="Registra aggiornamento"
    >
      <div className="flex flex-wrap gap-3">
        <label className="space-y-1 text-sm">
          <span className="block text-muted-foreground">
            Tipo di aggiornamento
          </span>
          <select
            className="h-9 rounded-md border border-input bg-background px-3"
            aria-label="Tipo di aggiornamento"
            value={kind}
            onChange={(e) => setKind(e.target.value)}
            disabled={isPending}
          >
            {updateKinds.map((value) => (
              <option key={value}>{value}</option>
            ))}
          </select>
        </label>
        {kind !== "Nota interna" && (
          <label className="space-y-1 text-sm">
            <span className="block text-muted-foreground">Canale</span>
            <select
              className="h-9 rounded-md border border-input bg-background px-3"
              aria-label="Canale"
              value={channel}
              onChange={(e) => setChannel(e.target.value)}
              disabled={isPending}
            >
              {updateChannels.map((value) => (
                <option key={value}>{value}</option>
              ))}
            </select>
          </label>
        )}
      </div>
      <Textarea
        aria-label="Cosa è successo"
        placeholder="Cosa è successo e cosa deve sapere l’altra persona?"
        value={text}
        onChange={(e) => setText(e.target.value)}
        disabled={isPending}
        rows={3}
      />
      <p className="text-xs text-muted-foreground">
        Salvare una bozza non significa averla inviata. La fase commerciale si
        aggiorna separatamente.
      </p>
      {failed && (
        <p role="alert" className="text-sm">
          Aggiornamento non salvato. Il testo è rimasto qui: riprova.
        </p>
      )}
      <Button
        type="submit"
        size="sm"
        disabled={!identity || !text.trim() || isPending}
      >
        {isPending ? "Salvataggio…" : "Salva aggiornamento"}
      </Button>
    </form>
  );
};
